import React from 'react';
import { connect } from 'react-redux';

import {
  setHeaderText,
  setBold,
  setFontSize,
  deleteData
} from '../../../../../../_actions/document-builder.actions';

function HeaderProperties({ item, dispatch }) {
  return <>
    <div className="form-group">
      <label htmlFor="question"><strong>Enter Header:</strong></label>
      <input
        onChange={(e) => { dispatch(setHeaderText(e.target.value)) }}
        value={item.text || ''}
        type="text"
        className="form-control"
      />
    </div>

    <div className="form-group">
      <label><strong>Bold Font</strong></label>
      <div className="custom-control custom-switch">
        <input
          onChange={(e) => { dispatch(setBold(e.target.checked)) }}
          id="boldCheckbox"
          checked={item.bold || false}
          value="note"
          type="checkbox"
          className="custom-control-input" />
        <label
          htmlFor="boldCheckbox"
          className="custom-control-label">Bold</label>
      </div>
    </div>

    <div className="form-group">
      <label><strong>Font Size</strong></label>

      <div className="form-check">
        <input
          onChange={(e) => { dispatch(setFontSize(e.target.value)) }}
          id="fontSizeSmall"
          name="fontSize"
          checked={item.fontSize === "small"}
          className="form-check-input"
          type="radio"
          value="small" />
        <label
          htmlFor="fontSizeSmall"
          className="form-check-label">Small</label>
      </div>

      <div className="form-check">
        <input
          onChange={(e) => { dispatch(setFontSize(e.target.value)) }}
          id="fontSizeMedium"
          name="fontSize"
          checked={item.fontSize === 'medium'}
          className="form-check-input"
          type="radio"
          value="medium" />
        <label
          htmlFor="fontSizeMedium"
          className="form-check-label">Medium</label>
      </div>

      <div className="form-check">
        <input
          onChange={(e) => { dispatch(setFontSize(e.target.value)) }}
          id="fontSizeLarge"
          name="fontSize"
          checked={item.fontSize === 'large'}
          className="form-check-input"
          type="radio"
          value="large" />
        <label
          htmlFor="fontSizeLarge"
          className="form-check-label">Large</label>
      </div>
    </div>

    <button
      onClick={() => {
        dispatch(deleteData());
      }}
      type="button" className="btn btn-outline-danger btn-block">Remove</button>
  </>
}

export default connect()(HeaderProperties);